import { memo } from 'react';
import { cn } from '@/ui/lib/utils';
import './spacer.css';

interface SpacerProps {
    min?: number;
    max?: number;
    variant: 'horizontal' | 'vertical';
}

export const Spacer = memo(({ variant, max, min = 0 }: SpacerProps) => {
    const customStyles = {
        '--max-space': max !== undefined ? `${max}px` : '100%',
        '--min-space': `${min}px`,
    } as React.CSSProperties;

    return (
        <div
            className={cn('spacer', `spacer--${variant}`)}
            style={customStyles}
            aria-hidden="true"
        ></div>
    );
});
